export const getToken = (state) => state.fetch.token || '';
